import React, { Dispatch, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
// import { Routes } from "../../../utils/constants";
// import { Link } from "react-router-dom";
import { fetchLogoutProxy, fetchUserInfo } from "../../utils/helpers/api";
import { authHelper } from "../../utils/helpers";
import { Http, Routes } from "../../utils/constants";
import { jwtDecode } from "jwt-decode";
import { useGlobalState } from "../../contexts/GlobalContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import routes from "../../utils/constants/routes";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { NotificationModal } from "../Commons/NotificationModal";

export type IMenuProps = {
  isShowMenu: boolean;
  onClickMenuItem: () => void;
  setIsShowMenu: Dispatch<React.SetStateAction<boolean>>;
};

const Menu: React.FC<IMenuProps> = (props) => {
  const { isShowMenu, onClickMenuItem, setIsShowMenu } = props;
  const [infoUser, setInfoUser] = useState<any>({});
  const [isSocialUser, setIsSocialUser] = useState<boolean>(false);
  const { setStateValue, globalState } = useGlobalState();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const serviceId = searchParams.get("serviceid");
  const location = useLocation();
  const [showBlockModal, setShowBlockModal] = useState(false);

  // useEffect(() => {
  //   const token = authHelper.accessToken();
  //   if (token) {
  //     const decode = jwtDecode(token);
  //     handleFetchUserInfo(decode.sub ?? "");
  //   }
  // }, []);

  useEffect(() => {
    if (globalState.user) {
      const isSocial = globalState.user?.identities?.some(
        (item: IIdentities) => item?.isSocial === true
      );
      setIsSocialUser(isSocial ?? false);
    }
  }, [globalState.user]);

  // const handleFetchUserInfo = async (user_id: string) => {
  //   try {
  //     const result = await fetchUserInfo(user_id ?? "");
  //     if (result?.status === Http.SUCCESS_CODE) {
  //       const isSocial = result.data?.identities?.some(
  //         (item: IIdentities) => item?.isSocial === true
  //       );
  //       setInfoUser(result.data);
  //       setIsSocialUser(isSocial ?? false);
  //     }
  //   } catch (err) {
  //     return err;
  //   }
  // };

  const handleLogout = async (e: any) => {
    e && e.preventDefault();
    setStateValue("loader", true);
    try {
      await fetchLogoutProxy();
    } catch (error) {
      return error;
    } finally {
      authHelper.logOut();
      navigate(Routes.USERGUEST);
      setStateValue("loader", false);
      setStateValue("user", null);
    }
  };

  const handleClick = (e: React.MouseEvent, item: any) => {
    e.preventDefault();
    const userStatus = globalState?.user?.user_metadata?.user_status;
    if ((userStatus === 1 || userStatus === 3 || userStatus === 5)  && !([Routes.WITHDRAWAL, Routes.LOGOUT, Routes.USERSETTING].includes(item.link))) {
      setIsShowMenu(false);
      setShowBlockModal(true);
      return;
    }

    if (item.action) {
      item.action(e);
    } else if (item.link) {
      navigate(item.link);
    }
    setIsShowMenu(false);
  };

  const menuItems = [ 
    {
      // icon: "../images/menu/Information.svg",
      label: "お客様情報の登録・変更",
      link: serviceId
        ? `${Routes.USERSETTING}?serviceid=${serviceId}`
        : Routes.USERSETTING,
    },
    // {
    //   // icon: "../images/menu/history.svg",
    //   label: "お支払い・ご利用履歴",
    //   link: "",
    // },
    {
      // icon: "../images/menu/Email.svg",
      label: "メルマガ受信設定",
      link: serviceId
        ? `${Routes.NOTIFICATION}?serviceid=${serviceId}`
        : Routes.NOTIFICATION,
    },
    ...(!isSocialUser
      ? [
          {
            icon: "",
            label: "メールアドレス設定",
            link: Routes.EMAILSETTING,
          },
          {
            icon: "",
            label: "パスワード設定",
            link: Routes.PASSWORDSETTING,
          },
        ]
      : []),
    {
      icon: "",
      label: "保存した記事",
      link: Routes.CLIPPING,
    },
    {
      iconClassName: "mb-1",
      // icon: "../images/menu/Logout.svg",
      label: "ログアウト",
      link: Routes.LOGOUT,
      action: handleLogout,
    },
    {
      icon: "",
      label: "退会",
      link: Routes.WITHDRAWAL,
    },
    // {
    //   icon: "../images/menu/Inquiry.svg",
    //   label: "お問い合わせ",
    //   link: ""
    // },
    // {
    //   icon: "../images/menu/questions.svg",
    //   label: "よくあるご質問",
    //   link: ""
    // },
  ];

  // const helpItems = [
  //   { icon: "../images/menu/Contact.svg", label: "お問い合わせ", link: "#" },
  //   {
  //     icon: "../images/menu/questions.svg",
  //     label: "よくあるご質問",
  //     link: "#",
  //   },
  // ];

  useEffect(() => {
    window.onresize = () => {
      const { innerWidth } = window;
      if (innerWidth > 768) {
        setIsShowMenu(true);
      }
      if (innerWidth <= 768) {
        setIsShowMenu(false);
      }
    };
  }, []);

  return (
    globalState.user && (
      <div className={`app-menu ${isShowMenu ? "active" : ""}`}>
        <h3 className="app-menu__name">設定</h3>
        <div className="app-menu__list">
          {menuItems.map((item, index) => {
            return (
              <a
                key={index}
                onClick={(e) => handleClick(e, item)}
                href={item.link}
                className={location.pathname === item.link ? "active" : ""}
              >
                {item.icon ? (
                  <>
                    {" "}
                    <img
                      className={item.iconClassName}
                      src={item.icon}
                      alt=""
                    />
                  </>
                ) : (
                  <></>
                )}
                <span>{item.label}</span>
              </a>
            );
          })}
        </div>

        {/* <div className="app-menu__list">
        {helpItems.map((item, index) => (
          <a key={index} href={item.link} className="">
            <img src={item.icon} alt="" />
            <span>{item.label}</span>
          </a>
        ))}
      </div> */}
      <NotificationModal
        isOpen={showBlockModal}
        title=""
        message="お客様情報のご登録がまだ完了しておりません。ご利用にあたっては、登録手続きをお願いいたします。"
        onClose={() => setShowBlockModal(false)}
        duration={3000}
      />
      </div>
    )
  );
};

export default Menu;
